module.exports = "<div class=\"main_block fullh\">\n  <div class=\"background_image\">\n  </div>\n\n  <div class=\"overlay\"></div>\n  <div class=\"overlay2\"></div>\n\n  <div class=\"foreground_text\">\n    <h1>OOOPS</h1>\n    <p>\n        We can't seem to find what you're looking for...\n        <br />\n        Where did you want to go?\n    </p>\n  </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-content/no-content.component.html
// module id = 243
// module chunks = 0